export const TRIAL_MODAL_SETTINGS = {
    primaryAction: {
        label: 'View Plans',
        href: process.env.REACT_APP_PLANS_URL || 'https://tlrg.com.au/pages/rpl-robot',
        external: true
    },
    secondaryAction: {
        label: 'Contact Administrator',
        href: process.env.REACT_APP_PLANS_ADMINISTRATOR || 'https://tlrg.com.au/pages/contact',
        external: true
    }
};
